/* eslint-disable no-empty-pattern */
import {put, select, delay} from 'redux-saga/effects'
//import {push} from 'connected-react-router'

import NotificationsActions, {NotificationsSelectors} from '../Redux/NotificationsRedux'
import ErrorsActions from '../Redux/ErrorsRedux'
//import AuthActions from '../Redux/AuthRedux'

const fakeData = {
  email: [
    {
      id: 1,
      selected: true,
      name: 'newsletter',
      title: 'Newsletter',
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Et faucibus est sit leo nunc',
    },
    {
      id: 2,
      selected: true,
      name: 'inside_app',
      title: 'Inside app notifications',
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Et faucibus est sit leo nunc',
    },
    {
      id: 3,
      selected: true,
      name: 'billing',
      title: 'Billing Notifications',
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Et faucibus est sit leo nunc',
    },
  ],
  push: [
    {
      id: 4,
      selected: false,
      name: 'invoices',
      title: 'Invoices',
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Et faucibus est sit leo nunc',
    },
    {
      id: 5,
      selected: false,
      name: 'privacy_changes',
      title: 'Privacy Changes',
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Et faucibus est sit leo nunc',
    },
    {
      id: 6,
      selected: false,
      name: 'notifications',
      title: 'Notifications',
      description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Et faucibus est sit leo nunc',
    },
  ],
}

export function* getNotifications(api, authApi, {}) {
  try {
    let state = yield select(NotificationsSelectors.getData)
    yield delay(1000)
    if (state) {
      yield put(NotificationsActions.notificationsSuccess(state))
    } else {
      yield put(NotificationsActions.notificationsSuccess(fakeData))
    }

    /*const response = yield call(api.getNotifications)
    if (response && response.ok) {
      yield put(NotificationsActions.notificationsSuccess(response.data))
    } else {
      if (response && response.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else if (response.status === 500) {
          yield put(ErrorsActions.errorSave("Server response error"))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave("Server response error"))
      }
      yield put(NotificationsActions.notificationsFetchingReset())
    }

    if (response && response.status === 401) {
      const res = yield call(authApi.tokenRefresh)
      if (res && res.access) {
        yield put(AuthActions.updateTokens(res.access, res.refresh))
        yield* getNotifications(api, authApi, {})
      } else {
        yield put(AuthActions.logout())
        yield put(push('/login'))
      }
    }*/
  } catch (e) {
    yield put(NotificationsActions.notificationsFetchingReset())
    yield put(ErrorsActions.errorSave('Server response error: ' + e))
  }
}

export function* updateNotifications(api, authApi, {data}) {
  try {
    yield delay(600)
    yield put(NotificationsActions.updateNotificationsSuccess(data))

    /*const response = yield call(api.updateNotifications, data)
    //let state = yield select(PermissionsSelectors.getState)
    if (response && response.ok) {
      yield put(NotificationsActions.updateNotificationsSuccess(response.data))
    } else {
      if (response && response.data) {
        if (response.status === 401) {
          yield put(ErrorsActions.errorSave(null))
        } else if (response.status === 500) {
          yield put(ErrorsActions.errorSave("Server response error"))
        } else {
          yield put(ErrorsActions.errorSave(response.data))
        }
      } else {
        yield put(ErrorsActions.errorSave("Server response error"))
      }
      yield put(NotificationsActions.notificationsFetchingReset())
    }

    if (response && response.status === 401) {
      const res = yield call(authApi.tokenRefresh)
      if (res && res.access) {
        yield put(AuthActions.updateTokens(res.access, res.refresh))
        yield* updateNotifications(api, authApi, {data})
      } else {
        yield put(AuthActions.logout())
        yield put(push('/login'))
      }
    }*/
  } catch (e) {
    yield put(NotificationsActions.notificationsFetchingReset())
    yield put(ErrorsActions.errorSave('Server response error: ' + e))
  }
}
